import React from 'react';
import { IComponentCss } from '@tap/mui-ui';
import {
    FormControl, Grid, SelectChangeEvent,
} from '@mui/material';
import { DateRange, DateRangePicker } from '@mui/x-date-pickers-pro';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { FilterWidget } from '@tap/tap-ui';
import ruLocale from 'date-fns/locale/ru';
import { MultipleSelect } from '@tap/mui-ui';
import { IFilterContext, createFilterExports } from '@tap/tap-ui';
import { useDocuemtnSchema } from '@tap/doc-ui';
import { ManufactureAndSectorMultiSelect, useDepartment } from '@tap/tap-ui';
import { ruRU } from '@mui/x-date-pickers/locales';
import { dateTimeHelper } from '@tap/utils';

/**
 *  Поиск
 */

export type IIssueFilterValue = {
    dateFrom: Date | null,
    dateTo: Date | null,
    manufactories: string[],
    sectors: string[],
    departmentIds: number[],
    statusCodes?: string[],
    assigneeIds?: number[],
}

export const defaultFilterValue: IIssueFilterValue = {
    dateFrom: dateTimeHelper.getCurrentMonthRange()[0],
    dateTo: dateTimeHelper.getCurrentMonthRange()[1],
    manufactories: [],
    sectors: [],
    departmentIds: [],
    statusCodes: [],
    assigneeIds: [],
};


const css: IComponentCss = {
    rangeDateWrap: {
        '& > div': { width: '100%' },
        marginBottom: '12px',
    },
    select: {
        backgroundColor: '#ffffff',
    },
    dateRangePickerStyle: {
        '.MuiMultiInputDateRangeField-separator': {
            display: 'none',
        },
        '.MuiOutlinedInput-root': {
            background: 'white',
        },
    },
}


// Для выпадающих списков - выводит количество выбранных элементов
const renderSelectValue = (
    label: string,
    arrayOfElements: any[] | undefined,
    arrayOfSelectedElements: any[] | undefined,
): string => {
    // состояние: все
    if (
        (arrayOfSelectedElements?.length === 0)
        || (arrayOfSelectedElements?.length === arrayOfElements?.length)
    )
        return label + ': все'
    else
        return label + ': ' + arrayOfSelectedElements?.length + '/' + arrayOfElements?.length
};

export type IIssueFilterProps = IFilterContext<IIssueFilterValue>;

const Filter = ({ defaultValue, filterValue, applyFilter }: IIssueFilterProps) => {

    const [formValue, setFormValue] = React.useState<IIssueFilterValue>(filterValue || defaultValue);
    const manufactureAndSectorMultiSelectProps = useDepartment();

    const documentSchema = useDocuemtnSchema('QC'); // TODO: !!! 
    const statuses = documentSchema.settings.statusList;

    const handleCleanFilter = () => {
        setFormValue(defaultValue);
        applyFilter(defaultValue);
    };

    // Период: обработчик для выбора периода
    const handleChangeDateRange = (newPeriod: DateRange<Date>) => {
        setFormValue({ ...formValue, dateFrom: newPeriod[0], dateTo: newPeriod[1] });
    };


    // Статус: обработчик для выпадающего списка 
    const handleChangeSelectedStatuses = (e: SelectChangeEvent<string[]>) => {
        setFormValue({ ...formValue, statusCodes: e.target.value as string[] });
    };

    const handleApplyFilter = () => {
        applyFilter(formValue);
    };

    return (
        <FilterWidget handleCleanFilter={handleCleanFilter} handleUpdateFilter={handleApplyFilter}>
            <>
                {/* Период: выбор диапазона дат */}
                <Grid container
                    item
                    sx={css.rangeDateWrap}>
                    <LocalizationProvider
                        dateAdapter={AdapterDateFns}
                        localeText={{
                            ...ruRU.components.MuiLocalizationProvider.defaultProps.localeText,
                            start: 'с',
                            end: 'по',
                        }}
                        adapterLocale={ruLocale}
                    >
                        <DateRangePicker
                            value={[formValue.dateFrom, formValue.dateTo]}
                            onChange={newPeriod => handleChangeDateRange(newPeriod)}
                            slotProps={{
                                textField: {
                                    size: 'small',
                                },
                            }}
                            sx={css.dateRangePickerStyle}
                        />
                    </LocalizationProvider>
                </Grid>

                <ManufactureAndSectorMultiSelect
                    {...manufactureAndSectorMultiSelectProps}
                    value={{
                        manufactories: formValue.manufactories,
                        sectors: formValue.sectors,
                        departmentIds: formValue.departmentIds,
                    }}
                    onChange={({ manufactories, sectors, departmentIds }) => setFormValue({ ...formValue, manufactories, sectors, departmentIds })}
                />

                {/*Выпадающий список: Статус  */}
                <Grid container item>
                    <FormControl fullWidth sx={css.select}>
                        <MultipleSelect
                            options={statuses}
                            value={formValue.statusCodes}
                            getOptionKey={(item) => item.code}
                            getOptionValue={(item) => item.code}
                            renderOption={(item) => item.name}
                            onChange={handleChangeSelectedStatuses}
                            renderValue={() =>
                                renderSelectValue(
                                    'Статусы',
                                    statuses,
                                    formValue.statusCodes?.map(scode => statuses.find(s => s.code === scode)),
                                )}
                        />
                    </FormControl>
                </Grid>

            </>
        </FilterWidget>
    );
}


export const IssueFilter = createFilterExports<IIssueFilterValue, IIssueFilterProps>(Filter);